const Footer = () => `
    <footer role="contentinfo">
      <div class="row primary">
        <div class="column">
          <h3>Contact Us</h3>
          <address aria-labelledby="contact">
            <ul role="list">
              <li role="listitem">
                <a role="link" href="/">+44 345 678 903</a>
              </li>
              <li role="listitem">
                <a role="link" href="/">adobexd@mail.com</a>
              </li>
              <li role="listitem">
                <a role="link" href="/">Find a Store</a>
              </li>
            </ul>
          </address>
        </div>
        <div class="column">
          <h3>Customer Service</h3>
          <ul role="list">
            <li role="listitem">
              <a role="link" href="/">Contact Us</a>
            </li>
            <li role="listitem">
              <a role="link" href="/">Ordering & Payment</a>
            </li>
            <li role="listitem">
              <a role="link" href="/">Shipping</a>
            </li>
            <li role="listitem">
              <a role="link" href="/">Returns</a>
            </li>
            <li role="listitem">
              <a role="link" href="/">FAQ</a>
            </li>
          </ul>
        </div>
         <div class="column">
          <h3>Information</h3>
          <ul role="list">
            <li role="listitem">
              <a role="link" href="/">About this example</a>
            </li>
            <li role="listitem">
              <a role="link" href="/">Work With US</a>
            </li>
            <li role="listitem">
              <a role="link" href="/">Privacy Policy</a>
            </li>
            <li role="listitem">
              <a role="link" href="/">Terms & Conditions</a>
            </li>
            <li role="listitem">
              <a role="link" href="/">Press Enquiries</a>
            </li>
          </ul>
        </div>
        <div class="column">
          <h4>Subscribe to us via Email</h4>
          <ul role="list">
            <li role="listitem">
                <p>Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia</p>
            </li>
          </ul>
          <form name="email-subscribe-form" aria-labelledby="email-subscribe" class="subscribe-container">
            <input type="email" placeholder="Email address" />
            <button>Subscribe</button>
          </form>
        </div>
      </div>
    </footer>
`;

export default Footer;
